import { CreditCardType } from './type'
import Visual from './Visual'

const CreditCard = ({ orderId }: CreditCardType) => {
  return <Visual orderId={orderId}/>
}

export default CreditCard
